import React from 'react';
import Button from './Button';

const dummyProjects = {
  '/web-design': [
    { image: '/web-design/5.png', label: 'Zarder | Website', link: 'https://www.zarder.app/' },
    { image: '/web-design/1.png', label: 'Safebite | Website', link: 'https://safebite.suppersquad.app' },
    { image: '/web-design/2.png', label: 'SupperSquad | Website', link: 'https://suppersquad.app' },
    { image: '/web-design/3.png', label: 'MIDDLEGROUNDS | Website', link: 'https://middlegroundsnews.com' },
    { image: '/web-design/4.png', label: 'Pippa | Website', link: 'https://getpippa.app' }
  ],
  '/social-media': [
    { image: '/social-media/media1.jpeg', label: 'Creators Brand | Social Media', link: 'https://www.instagram.com/creators_brand/' },
    { image: '/social-media/media2.png', label: 'Pippa | Social Media', link: 'https://www.instagram.com/getpippa/' }
  ],
  '/logos': [
    { name: 'Safebite', image: '/client-images/safebite.png', link: 'https://safebite.suppersquad.app' },
    { name: 'Zarder', image: '/client-images/zarderFull.png', link: 'https://www.zarder.app/' },
    { name: 'Woe', image: '/client-images/woe.png' },
    { name: 'Middlegrounds', image: '/client-images/middlegrounds.png', link: 'https://middlegroundsnews.com' },
    { name: 'Pippa', image: '/client-images/pippa.png', link: 'https://getpippa.app' },
    { name: 'Supper Squad', image: '/client-images/suppersquad.png', link: 'https://suppersquad.app' },
    { name: 'Codely', image: '/client-images/codely.png', link: 'https://codelyapp.vercel.app' },
    { name: 'Albumified', image: '/client-images/albumified.png', link: 'https://www.albumified.com/' },
    { name: 'Icebreakers', image: '/client-images/icebreakers.png', link: 'https://icebreakers-daily.vercel.app' },
  ],
  '/automation': [
    {
      title: 'Automated Email Engine',
      description: "Transformed audience outreach by building a custom workflow that automatically detects the day's most compelling story and delivers it straight to subscribers. Shifted the focus from manual curation to high-impact delivery, resulting in an 80% spike in email engagement.",
      image: '/automation-images/middleground.jpg',
      tags: 'workflows, automation, email strategy, audience-growth',
      link: 'https://www.middlegroundsnews.com'
    },
    {
      title: 'OpenClaw Inbox Automation',
      description: 'Deployed an intelligent OpenClaw system for Middlegrounds to automatically read, interpret, and resolve any outstanding reader emails. This smart automation instantly cleared their inbox backlog and provides ongoing, instant 24/7 responses.',
      image: '/automation-images/openclaw.webp',
      tags: 'automation, ai, customer support, inbox-management',
      link: 'https://www.middlegroundsnews.com'
    },
    {
      title: 'Albumified Content Automation',
      description: 'Designed a seamless automation ecosystem for Albumified that synchronizes content updates across their platform and dynamically triggers personalized user engagement campaigns, completely eliminating manual marketing tasks.',
      image: '/automation-images/albumified.png',
      tags: 'automation, content sync, user engagement, music tech',
      link: 'https://www.albumified.com/'
    }
  ],
  '/microservices': [
    {
      title: 'Payment Processing & Invoicing',
      description: 'We engineered a seamless checkout and invoicing microservice for SupperSquad. By integrating a highly secure, customized payment sequence, we eliminated all manual data entry. The system now automatically handles immediate receipt generation and fires off overdue bill reminders completely behind the scenes.',
      image: '/microservice-images/payment.jpg',
      tags: 'microservices, payment-processing, automation, invoicing',
      link: 'https://suppersquad.app'
    },
    {
      title: 'Safebite Digital Infrastructure',
      description: 'We rewired Safebite\'s digital foundation so their platform handles massive surges in traffic effortlessly. Instead of relying on one large, breakable system, we broke it into smaller, ultra-fast, independent pieces. This means their customers never experience slowdowns or crashes, even during their absolute busiest hours.',
      image: '/microservice-images/safebite.jpg',
      tags: 'microservices, performance, reliability, architecture',
      link: 'https://safebite.suppersquad.app'
    }
  ]
};

dummyProjects['/work'] = [
  { image: dummyProjects['/web-design'][0].image, label: 'WEB DESIGN', link: '/web-design' },
  { image: dummyProjects['/social-media'][0].image, label: 'SOCIAL MEDIA', link: '/social-media' },
  { image: dummyProjects['/logos'][0].image, label: 'LOGOS', link: '/logos' },
  { image: dummyProjects['/automation'][0].image, label: 'AUTOMATION', link: '/automation' },
  { image: dummyProjects['/microservices'][0].image, label: 'MICROSERVICES', link: '/microservices' }
];

const servicesList = [
  { name: 'Web Design', path: '/web-design' },
  { name: 'Social Media', path: '/social-media' },
  { name: 'Logos', path: '/logos' },
  { name: 'Automation', path: '/automation' },
  { name: 'Microservices', path: '/microservices' },
];

const ServiceShowcase = ({ currentPath, navigate }) => {
  const projects = dummyProjects[currentPath] || dummyProjects['/web-design'];

  return (
    <div id="service-showcase" className={`w-full mb-8 ${currentPath === '/work' ? 'mt-4 md:mt-8' : 'mt-16'}` }>
      {/* Top Menu Bar */}
      {currentPath !== '/work' && (
        <div className="flex flex-col lg:flex-row lg:items-center justify-between border-b-2 border-border pb-6 mb-12 gap-6">
          <h2 className="text-xl md:text-2xl font-bold uppercase tracking-widest text-foreground" style={{ fontFamily: "'Poppins Black', sans-serif" }}>
            OUR SERVICES
          </h2>
          <div className="flex flex-wrap gap-4 md:gap-6 justify-start lg:justify-end">
            {servicesList.map((service) => (
              <button
                key={service.path}
                onClick={() => {
                  const showcase = document.getElementById('service-showcase');
                  const offset = showcase ? showcase.getBoundingClientRect().top : 0;
                  
                  navigate(service.path, {}, true);
                  
                  setTimeout(() => {
                    const newShowcase = document.getElementById('service-showcase');
                    if (newShowcase) {
                      const newTop = newShowcase.getBoundingClientRect().top + window.scrollY;
                      window.scrollTo({ top: newTop - offset, behavior: 'instant' });
                    }
                  }, 0);
                }}
                className={`text-sm md:text-base font-bold transition-colors ${
                  currentPath === service.path
                    ? 'text-accent'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {service.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Conditional Rendering: Logo Grid vs Project List */}
      {currentPath === '/logos' ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {projects.map((logo, idx) => (
            <a 
              key={idx}
              href={logo.link}
              target="_blank"
              rel="noopener noreferrer"
              className="relative bg-muted/30 border-2 border-border aspect-square flex items-center justify-center p-8 md:p-12 hover:border-accent transition-all duration-300 group cursor-pointer overflow-hidden"
            >
              {/* Overlay */}
              <div className="absolute inset-0 bg-accent/[0.66] opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 pointer-events-none"></div>
              
              <img 
                src={logo.image} 
                alt={`${logo.name} Logo`} 
                className="relative z-0 max-w-full max-h-full object-contain opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500"
                draggable="false"
              />
            </a>
          ))}
        </div>
      ) : currentPath === '/web-design' || currentPath === '/social-media' || currentPath === '/work' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, idx) => (
            <a 
              key={idx}
              href={project.link}
              target={project.link.startsWith('/') ? "_self" : "_blank"}
              rel={project.link.startsWith('/') ? undefined : "noopener noreferrer"}
              onClick={(e) => {
                if (project.link.startsWith('/')) {
                  e.preventDefault();
                  navigate(project.link);
                }
              }}
              className="relative aspect-square bg-muted/30 border-2 border-border overflow-hidden group cursor-pointer hover:border-accent transition-all duration-300 block"
            >
              <div className="absolute inset-0 bg-accent/[0.66] opacity-0 group-hover:opacity-100 transition-all duration-300 z-10 flex items-center justify-center">
                <span className={`text-white font-bold uppercase tracking-widest transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 text-center px-4 ${currentPath === '/social-media' ? 'text-sm md:text-base' : 'text-lg md:text-xl'}`} style={{ fontFamily: "'Poppins Black', sans-serif" }}>
                  {project.label}
                </span>
              </div>
              
              <img 
                src={project.image} 
                alt={project.label} 
                className={`w-full h-full transition-transform duration-500 group-hover:scale-105 ${project.label === 'LOGOS' ? 'object-contain p-12' : 'object-cover'}`}
                draggable="false"
              />
            </a>
          ))}
        </div>
      ) : (
        <div className="space-y-12">
          {projects.map((project, idx) => (
            <div key={idx} className="flex flex-col md:flex-row bg-muted/30 border-2 border-border overflow-hidden">
              {/* Image Container */}
              <div className="w-full md:w-[40%] bg-muted flex items-center justify-center p-0 shrink-0">
                <img 
                  src={project.image} 
                  alt={project.title} 
                  className="w-full h-full object-cover aspect-square md:aspect-auto"
                />
              </div>
              
              {/* Content Container */}
              <div className="w-full md:w-[60%] p-6 md:p-10 flex flex-col justify-center bg-background">
                <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3" style={{ fontFamily: "'Poppins Black', sans-serif" }}>
                  {project.title}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground mb-6 leading-relaxed">
                  {project.description}
                </p>
                <div className="mb-6">
                  {project.link ? (
                    <a href={project.link} target="_blank" rel="noopener noreferrer">
                      <Button size="default" className="text-sm px-8">
                        VIEW
                      </Button>
                    </a>
                  ) : (
                    <Button size="default" className="text-sm px-8">
                      VIEW
                    </Button>
                  )}
                </div>
                <p className="text-xs md:text-sm italic text-muted-foreground font-medium mt-auto">
                  {project.tags}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServiceShowcase;
